/* tslint:disable */
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MappingService } from './mapping.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Msisdn } from '../../shared/msisdn/msisdns';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { NotificationService } from '../../shared/notification.service';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cc-mapping',
  templateUrl: './mapping.component.html',
  styleUrls: ['./mapping.component.scss']
})
export class MappingComponent implements OnInit, OnChanges {
  @Input() campaignId;
  @Input() mappingEnabled;
  @Input() callerIdRandomChoiceEnabled;
  @Input() updateProjectNumbers;
  @Input() active;

  public msisdnsList: Msisdn[];
  public editMode = [];
  public mappingForm: FormArray;
  public callerType: string;
  public showBlock = false;

  constructor(
    private mappingService: MappingService,
    private msisdnService: MsisdnService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private notify: NotificationService
  ) {}

  ngOnInit() {
    this.mappingForm = this.createForm();
    this.prepareForm();
    this.setProjectNumber();
    this.updateProjectNumbers.subscribe(numbers => {
      this.msisdnsList = numbers.campaignsMsisdns;
      this.prepareForm();
    });
    this.callerType = this.setTypeIfExist();
    this.callerType && (this.showBlock = true);
  }

  setTypeIfExist() {
    if (this.mappingEnabled) {
      return 'multiselect';
    } else if (this.callerIdRandomChoiceEnabled) {
      return 'shuffle';
    } else {
      null;
    }
  }

  createForm() {
    return this.fb.array([this.createMapping()]);
  }

  setProjectNumber() {
    this.msisdnService.projectNumbers(this.campaignId).subscribe((msisdnsList: any) => {
      this.msisdnsList = msisdnsList.campaignsMsisdns;
    });
  }

  createMapping(mappingItem = {} as any) {
    return this.fb.group({
      id: mappingItem.id || null,
      isoCountry: [mappingItem.isoCountry || null, Validators.required],
      msisdnId: [mappingItem.msisdnId || '', Validators.required],
      pattern: [mappingItem.pattern || '', [Validators.required, this.isPresentIsoCodeAndPattern]],
      callerIdLabel: mappingItem.callerIdLabel || '',
      callerIdCountryCode: mappingItem.callerIdCountryCode || ''
    });
  }

  onChangeMapping(selectValue) {
    this.mappingService.enableMapping(this.campaignId, selectValue).subscribe(() => {
      this.mappingEnabled = !this.mappingEnabled;
    });
  }

  addMapping(form: FormGroup) {
    this.mappingService.addNewMapping(this.campaignId, form.getRawValue()).subscribe(() => {
      this.notify.open('MAPPING.MESSAGES.ADD');
      form.reset();
      this.prepareForm();
    });
  }

  editMapping(form: FormGroup) {
    this.mappingService.editMapping(this.campaignId, form.getRawValue()).subscribe(() => {
      this.notify.open('MAPPING.MESSAGES.EDIT');
      this.prepareForm();
    });
  }

  prepareForm() {
    this.mappingService.mapping(this.campaignId).subscribe(mapping => {
      this.mappingForm.controls = [this.mappingForm.controls[0]];
      this.editMode = [];
      (mapping as any).forEach(el => {
        this.mappingForm.controls.push(this.createMapping(el));
      });
    });
  }

  onChangeShuffle(selectValue) {
    this.mappingService.enableShuffle(this.campaignId, selectValue).subscribe(() => {
      this.callerIdRandomChoiceEnabled = !this.callerIdRandomChoiceEnabled;
    });
  }

  onChangeEditMode(id) {
    this.editMode[id] = true;
  }

  selectType(type) {
    this.callerType = type;
    this.isMultiSelect ? this.onChangeMapping(true) : this.onChangeShuffle(true);
  }

  get isMultiSelect() {
    return this.callerType === 'multiselect';
  }

  get isShuffle() {
    return this.callerType === 'shuffle';
  }

  toggleShowBlock() {
    this.showBlock = !this.showBlock;
    if (!this.showBlock) {
      this.callerType = '';
      this.disableAll();
    }
  }

  disableAll() {
    this.onChangeMapping(false);
    this.onChangeShuffle(false);
  }

  onDelete(mappingId) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'MAPPING.MODAL.HEADER',
          body: 'MAPPING.MODAL.BODY'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.mappingService.remove(this.campaignId, mappingId).subscribe(() => {
            this.prepareForm();
          });
        }
      });
  }

  isPresentIsoCodeAndPattern(control: FormControl) {
    return control.parent && control.parent.get('isoCountry').valid ? null : { isoCountry: true };
  }

  ngOnChanges() {
    this.active && this.disableAll();
  }
}
